import { fitroomViewportModuleContext } from '@seddi/ui-babylon-fitroom';
import { homeActions } from '../slices/homeSlice';
import { HomeDispatch, HomeGetState } from '../store/homeStore';

export const toggleHeatMap = (
  dispatch: HomeDispatch,
  getState: HomeGetState,
  isHeatMap: boolean,
) => {
  // Update state.
  dispatch(homeActions.toggleHeatMap());

  // Update visualization.
  const context = fitroomViewportModuleContext();
  context.toggleHeatMap(isHeatMap);
};
